import { AlertConfirm, DestructiveConfirmation } from "components/WebDesigner/ConfirmationPopups";
import { useState, useRef, useEffect } from "react";
import ReactDOM from "react-dom";
import Loader from "vagaro-website-rendering/src/components/Common/Loader";
import VGPopUp from "vagaro-website-rendering/src/components/Controls/VGPopUp";
import {  AddSetCategory, DeleteSetCategory, EditSetCategory, GetSetCategories, SetType } from "./SetLibraryAPI";
import { UserContext } from "vagaro-website-rendering/src/components/Definitions/UserContext";

export default function SetCategoryPopUp(){

}


export function EditSetCategoryPopUp({setType}:{setType:SetType}){



}



export function StyleSetCategoryMenu({setType,inCategories,userContext,onDismiss,onUpdateCategories}:{setType:SetType,inCategories:any[],userContext:UserContext,onDismiss:()=>void,onUpdateCategories?:()=>void}){   

    const [categories,setCategories] = useState<any[]>(inCategories);
    const [isLoading,setIsloading] = useState(inCategories.length==0);
    const inputRef = useRef<HTMLInputElement>(null);
    const [validationMessage,setValidationMessage] = useState("");

    const [isUpdatingCat,setIsUpdatingCat] = useState(false);
    const [updateCatName,setUpdateCatName] = useState("");
    const [updateCatId,setUpdateCatId] = useState("");




    const toAdd = useRef<string[]>([]);
    const toUpdate = useRef<{id:string,name:string}[]>([]);

    const loadInCategories = (callBack?:()=>void)=>{
        GetSetCategories(userContext,setType,(data:any)=>{
            setCategories(data?.data?.data??[]);
            setIsloading(false);
            callBack && callBack();
          
        },
        (error:any)=>{
            console.error(error);
            AlertConfirm("Error loading categories");
            setIsloading(false);
        
        }
        );

    }

    const onInput = (e:any)=>{


        if(validationMessage.length>0){
            setValidationMessage("");
        }

        if(!inputRef.current)
            return;
        if(inputRef.current.value.length<=0&&isUpdatingCat){
       
            setIsUpdatingCat(false);
        }
    
    }


    useEffect(()=>{
        if(inCategories.length==0){
            

            loadInCategories();
        }

        if(inputRef.current){
            inputRef.current.focus();
        }

        
//eslint-disable-next-line
    },[]);



    const TrySave =()=>{

        if(toAdd.current.length==0&&toUpdate.current.length==0){
            onDismiss();


            return;
        }

        let promises:Promise<any>[] = [];

        toAdd.current.forEach((name)=>{

            promises.push(AddSetCategory(userContext,setType,name,()=>{},(error:any)=>{}));

        });

        toUpdate.current.forEach((cat)=>{
            promises.push(EditSetCategory(userContext,setType,cat.id,cat.name,()=>{},(error:any)=>{}));
        })


        setIsloading(true);

        Promise.all(promises).then((data:any)=>{
            setIsloading(false);
            loadInCategories(()=>{
                onUpdateCategories && onUpdateCategories();
                onDismiss();
            });
            toAdd.current = [];
            toUpdate.current = [];
          
           
     
        }).catch((error:any)=>{
            setIsloading(false);
            AlertConfirm("Error saving categories");
            console.error(error);
        });


    

    }   

    // const ValidationMessage = (message:string)=>{
    //     if(!inputRef.current){
    //         return;
    //     }

    // }

    const TryDelete = (catName:string,categoryId:string)=>{
    
        DestructiveConfirmation(<span>{"Are you sure you want to delete the category "}<b>{catName}</b>?</span>,()=>{
            setIsloading(true);
            if(categoryId.length>0)
            DeleteSetCategory(userContext,setType, categoryId,(data:any)=>{
                setIsloading(false);
                loadInCategories();
                toAdd.current = [];
                toUpdate.current = [];
                onUpdateCategories && onUpdateCategories();
            },(error:any)=>{
                setIsloading(false);
                console.error(error);
            });
            else{
                loadInCategories();
            }
      
        },()=>{return});
   
    }
    
    let inputStyle:any = {height:"40px"};

    if(validationMessage.length>0){
        inputStyle = {...inputStyle,border:"1px solid #B42318",background:"#FBEFEF"};
    }

    return <>
    <div className="wb-input-group no-border" style={{padding:"0"}}>
        {isLoading && <Loader/>}
        <div style={{opacity:".6",fontWeight:"normal"}}>Add a new section category name</div>
        <br/>
        <label style={{fontSize:"18px"}}>New Category Name:</label>
       <div className="flex-row gap-med form-row-invalid align-start ">
        <div className="w-full justify-end">
        <input
        
        ref={inputRef} maxLength={32} type="text" className="w-full" onInput={onInput} style={inputStyle} placeholder="Enter Name"/>
        {validationMessage.length>0 && <div className="invalid-feedback" style={{fontWeight:"400"}}>{validationMessage}</div>}
        </div>
        { !isUpdatingCat?
        <button className="w-button w-button-neutral"
        onClick={(e) => {
            if(inputRef.current){
            let val = (inputRef.current?.value as string);
            if(val.length >0 ){
            
                if(categories.findIndex((c)=>c.name.toLowerCase()==val.toLowerCase())<0){
                    toAdd.current.push(val);
                    let cat = categories;
                    cat.push({name:val,id:""});
                    inputRef.current.value = "";
                    setCategories([...cat]);
                
                }
                else{
                    setValidationMessage("Category name already exists");
                }

            }
            else{
                setValidationMessage("Please Enter New Category Name");
            }
        }


        }}
        
        
        >Add</button>
        :
        <button className="w-button w-button-neutral" 
        onClick={(e) => {
                if(inputRef.current){
                    let val = (inputRef.current?.value as string);
                    if(val.length >0 ){
                    
                        if(categories.findIndex((c)=>c.name.toLowerCase()==val.toLowerCase())<0){
                            
                     

                                let index = toAdd.current.indexOf(updateCatName);
                                if(index>=0){
                                toAdd.current[index] = val;
                                }
                                else{
                                    index = toUpdate.current.findIndex((c)=>c.id==updateCatId);

                                    if(index>0){
                                        toUpdate.current[index].name = val;
                                    }
                                    else{
                                        toUpdate.current.push({id:updateCatId,name:val});
                                    }
                                    categories.forEach((c)=>{
                                        if(c.name==updateCatName){
                                            c.name = val;
                                        }
                                    });
                                }
                                inputRef.current.value = "";
                                setCategories([...categories]);
                        }
                        
                        else{
                            setValidationMessage("Category name already exists");
                        }

                    }
                    else{
                        setValidationMessage("Please Enter New Category Name");
                    }
                }
        }}
        >Update</button>
        }
        </div>
        <br/>
        <label style={{fontSize:"18px"}}>Current Categories</label>
        <div style={{opacity:".6",marginBottom:"12px",fontWeight:"normal"}}>Remove a category by deleting it.</div>
        <div className="flex-row gap-med flex-wrap">
        {categories&&categories.length>0&& categories.map((c,i)=><CategoryChip onSelect={()=>{
            setIsUpdatingCat(true);
            setUpdateCatName(c.name);
            setUpdateCatId(c.id);
            if(inputRef.current){
                inputRef.current.value = c.name;
            }
            
        }} key={i} name={c.name} onDelete={()=>{
            TryDelete(c.name,c.id);
        }}/>)}
        </div>  
    </div>
    <br/>
    <div className="flex-row justify-end gap-large">    
        <button className="w-button w-button-secondary" onClick={(e) => { onDismiss()}}>Cancel</button>
        <button  id="save-category-button" className="w-button w-button-primary" onClick={(e) => { TrySave();}}>Save</button>
    </div>
      
    </>

}


export function OpenSetCategoryPopup(userContext:UserContext,setType:SetType,inCategories:any[],content?:string[],onUpdateCategories?:()=>void,onDismiss?:()=>void){

    
    const dom =  document.getElementById("OpenDialog2");
   
    const PopupClose = ()=>{

        if(dom){
            ReactDOM.unmountComponentAtNode(dom);
        }
    }

    let title = setType==SetType.Color?"Edit Color Categories":"Edit Font Categories";

    ReactDOM.render(
        <>
        <VGPopUp
          id={"cat-section-popup"}
          show={true}
          onHide={PopupClose}
          title={title}
          dialogClassName="block-edit"
          body={
            <div className="alertContent">
               <StyleSetCategoryMenu setType={setType} inCategories={inCategories} userContext={userContext} 
               onUpdateCategories={onUpdateCategories}
               onDismiss={()=>{PopupClose();
                        onDismiss&&onDismiss();
               
                    }
                } />
            </div>
          }

          isRemoveTabModalIndex={false}
          isShowFooter={false}
          size={"modal-sm"}
          backdrop={true}
        />
  
        </>,
        dom);

}

function CategoryChip({name,onDelete,onSelect}:{name:string,onDelete:()=>void,onSelect?:()=>void}){

    return <div onClick={onSelect} className="relative category-chip center-all gap-med" style={{ userSelect:"none",padding:"10px 12px 10px 16px",background:"#E7E7E7",borderRadius:"4px",fontWeight:"normal"}}>{name}
    <button className="invisible-button" style={{fontSize:"26px",fontWeight:"bold",userSelect:"none"}}
    onClick={(e)=>{e.stopPropagation();onDelete()}}
    >&times;</button>
    </div>

}